import { useEffect, useRef } from 'react';

export const useBankAccountFormSyncCl = ({
  existingBankData,
  banksData,
  selectedBank,
  selectedAccountType,
  reset,
  setValue,
  isSubmitting,
  isSavingData,
  isLoadingExistingData,
  isLoadingDataBankList,
  countryConfig,
}) => {
  const previousBankIdRef = useRef(null);
  const isSyncingRef = useRef(false);
  const previousAccountTypeValueRef = useRef(null);

  useEffect(() => {
    const shouldSyncForm = existingBankData?.data && banksData?.length > 0;

    if (shouldSyncForm) {
      const mappedData = countryConfig.mapperBankAccountFields({
        bankAccountData: existingBankData,
        bankListData: banksData,
      });

      isSyncingRef.current = true;
      previousBankIdRef.current = mappedData?.bank?.value;
      previousAccountTypeValueRef.current =
        mappedData.accountType?.value ?? null;

      reset(mappedData);

      requestAnimationFrame(() => {
        isSyncingRef.current = false;
      });
    }
  }, [existingBankData, banksData, reset, countryConfig]);

  useEffect(() => {
    if (isSyncingRef.current) return;
    const currentBankId = selectedBank?.value;

    if (
      currentBankId !== previousBankIdRef.current &&
      previousBankIdRef.current !== null
    ) {
      setValue('accountType', null, { shouldDirty: true });
    }

    previousBankIdRef.current = currentBankId;
  }, [selectedBank?.value, setValue]);

  const selectedAccountTypeValue = selectedAccountType?.value ?? null;

  useEffect(() => {
    if (isSyncingRef.current) return;

    if (selectedAccountTypeValue === null) return;

    if (selectedAccountTypeValue === previousAccountTypeValueRef.current)
      return;

    previousAccountTypeValueRef.current = selectedAccountTypeValue;

    setValue('accountType', selectedAccountType, {
      shouldDirty: true,
      shouldTouch: true,
    });
  }, [selectedAccountTypeValue, setValue, selectedAccountType]);

  const isLoadBlocking = isSubmitting || isSavingData || isLoadingExistingData;
  const isSaveDisabled = isLoadBlocking || isLoadingDataBankList;
  const isLoadingBankData = isLoadingDataBankList || isLoadingExistingData;

  return {
    isLoadBlocking,
    isSaveDisabled,
    isLoadingBankData,
  };
};
